<template>
    <div
        class="relative mx-auto w-full px-6 py-4"
        :class="{ 'w-3/5': isDesktop }"
    >
        <div class="overflow-hidden">
            <div
                :class="
                    isFewItems
                        ? 'flex justify-center gap-4'
                        : 'grid grid-cols-2 gap-4'
                "
            >
                <component
                    :is="item.href ? 'a' : 'div'"
                    v-for="item in pagedItems"
                    :key="item.key"
                    v-bind="linkAttrs(item)"
                    :aria-label="item.title"
                    class="flex overflow-hidden rounded-xl border-2 border-stack-text shadow-md no-underline"
                    :class="[
                        isDesktop ? 'h-80' : 'h-64',
                        isFewItems ? 'w-1/2' : 'w-full'
                    ]"
                    @click="onClick"
                >
                    <div class="h-full w-full overflow-hidden">
                        <img
                            v-if="item.imageUrl"
                            :src="item.imageUrl"
                            :alt="item.imageAlt"
                            class="h-full w-full object-cover"
                        />
                        <slot v-else name="placeholder" :item="item"></slot>
                    </div>
                </component>
            </div>
        </div>

        <button
            v-if="totalPages > 1"
            type="button"
            class="absolute left-0 top-1/2 z-30 flex -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full border bg-carousel-control shadow-md hover:bg-gray-100"
            :class="[
                isDesktop ? 'h-10 w-10' : 'h-6 w-6',
                { 'cursor-not-allowed opacity-50': atStart }
            ]"
            :disabled="atStart"
            aria-label="Anterior"
            @click="prevSlide"
        >
            <svg
                class="text-gray-700"
                :class="isDesktop ? 'h-6 w-6' : 'h-4 w-4'"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 19l-7-7 7-7"
                />
            </svg>
        </button>

        <button
            v-if="totalPages > 1"
            type="button"
            class="absolute right-0 top-1/2 z-30 flex -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full border bg-carousel-control shadow-md hover:bg-gray-100"
            :class="[
                isDesktop ? 'h-10 w-10' : 'h-6 w-6',
                { 'cursor-not-allowed opacity-50': atEnd }
            ]"
            :disabled="atEnd"
            aria-label="Siguiente"
            @click="nextSlide"
        >
            <svg
                class="text-gray-700"
                :class="isDesktop ? 'h-6 w-6' : 'h-4 w-4'"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                />
            </svg>
        </button>

        <div v-if="totalPages > 1" class="mt-4 flex justify-center space-x-2">
            <button
                v-for="i in totalPages"
                :key="i"
                type="button"
                class="h-2 w-2 rounded-full border border-stack-text transition-colors"
                :class="
                    currentPage === i - 1
                        ? 'bg-stack-emphasis'
                        : 'bg-stack-text'
                "
                :aria-label="`Ir a conjunto ${i}`"
                @click="goToSlide(i - 1)"
            ></button>
        </div>
    </div>
</template>

<script>
export default {
    name: "SliderV12",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    data: () => ({
        currentPage: 0
    }),
    computed: {
        // Valores de catalog para 1024–1279px (escritorio) y móvil; sin
        // listener de resize: el dispositivo lo simula `isDesktop`.
        rowsToShow() {
            return this.isDesktop ? 3 : 2;
        },
        colsToShow() {
            return 2;
        },
        atStart() {
            return this.currentPage === 0;
        },
        atEnd() {
            return this.currentPage >= this.totalPages - 1;
        },
        itemsPerPage() {
            return this.colsToShow * this.rowsToShow;
        },
        totalPages() {
            return Math.max(
                1,
                Math.ceil(this.items.length / this.itemsPerPage)
            );
        },
        pagedItems() {
            const start = this.currentPage * this.itemsPerPage;
            return this.items.slice(start, start + this.itemsPerPage);
        },
        // Menos ítems que columnas: la fila se centra (regla de "pocas
        // imágenes").
        isFewItems() {
            return this.pagedItems.length < this.colsToShow;
        }
    },
    watch: {
        items() {
            this.currentPage = 0;
        },
        isDesktop() {
            this.currentPage = 0;
        }
    },
    methods: {
        prevSlide() {
            if (this.atStart) return;
            this.currentPage--;
        },
        nextSlide() {
            if (this.atEnd) return;
            this.currentPage++;
        },
        goToSlide(index) {
            this.currentPage = index;
        },
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
